<template>
  <button
    @click="handleClick"
    :class="[
      'flex items-center gap-2 pl-2 pr-4 py-1.5 rounded-full transition-all md:ml-2 group',
      isSolid
        ? 'bg-gray-100 hover:bg-gray-200 text-gray-900'
        : 'bg-white/20 hover:bg-white/30 backdrop-blur-md text-white',
      storesCount === 1 ? 'pointer-events-none' : ''
    ]"
  >
    <div
      :class="[
        'p-1.5 rounded-full flex',
        isSolid
          ? 'bg-white text-primary-600 shadow-sm'
          : 'bg-white/20 text-white'
      ]"
    >
      <MapPin :size="16" />
    </div>
    <div class="flex flex-col items-start text-left mr-1">
      <span class="text-xs font-bold leading-tight truncate location-name">
        {{ locationName || storeAddress || "Select Location" }}
      </span>
      <span
        v-if="storeAddress && locationName"
        :class="[
          'font-medium leading-none truncate',
          isSolid ? 'text-gray-500' : 'text-white/80'
        ]"
        style="font-size: 10px; max-width: 140px;"
      >
        {{ storeAddress }}
      </span>
      <span
        v-else
        :class="[
          'font-medium leading-none',
          isSolid ? 'text-gray-500' : 'text-white/80'
        ]"
        style="font-size: 10px"
      >
        {{ storesCount }}
        {{ storesCount === 1 ? "location" : "locations" }} available
      </span>
    </div>
    <ChevronDown
      v-if="storesCount > 1"
      :size="14"
      class="opacity-70 ml-1 group-hover:translate-y-0.5 transition-transform"
    />
  </button>
</template>

<script>
import { MapPin, ChevronDown } from "lucide-vue";
import { useModalManagement } from "@/composables/useModalManagement";

export default {
  name: "LocationTrigger",
  components: {
    MapPin,
    ChevronDown
  },
  props: {
    locationName: {
      type: String,
      default: ""
    },
    storeAddress: {
      type: String,
      default: ""
    },
    storesCount: {
      type: Number,
      default: 0
    },
    isSolid: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this._modalManagement = useModalManagement(this.$store);
  },
  methods: {
    async handleClick() {
      this._modalManagement.setLocationModalOpen(true);
    }
  }
};
</script>

<style scoped>
.location-name {
  max-width: 120px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
}
</style>
